<div class="container-fluid">
    <div class="row">
        <div class="page-heading">
            <div class="page-title">
                <h2>{{ 'delivery_requests.title' | translate }}</h2>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-9">
            <p *ngIf="loading else data_loaded" class="loading-text">
                {{ 'common.loading' | translate }} ...
            </p>
            <ng-template #data_loaded>
                <div class="request-detail">
                    <div class="text-end mb-3">
                        <a [routerLink]="['/user/delivery-requests']" class="btn btn-success order-back-btn">
                            <i class="fa fa-arrow-left me-2"></i>{{ 'common.back' | translate }}
                        </a>
                    </div>

                    <div class="detail-header-card">
                        <div class="header-row">
                            <div class="header-item">
                                <span class="header-label">{{ 'delivery_requests.ref' | translate }}</span>
                                <span class="header-value">#{{ request?.deliveringRef }}</span>
                            </div>
                            <div class="header-item">
                                <span class="header-label">{{ 'common.status' | translate }}</span>
                                <span [class]="getStatusClass(request?.deliveryStatus)">{{ getDeliveryStatusLabel(request?.deliveryStatus) | translate }}</span>
                            </div>
                            <div class="header-item">
                                <span class="header-label">{{ 'delivery_requests.date' | translate }}</span>
                                <span class="header-value">{{ formatDate(request?.createdAt) }}</span>
                            </div>
                            <div class="header-item">
                                <span class="header-label">{{ 'delivery_requests.amount' | translate }}</span>
                                <span class="header-value amount">{{ formatCurrency(request?.deliveringAmount) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h6 class="section-title">{{ 'delivery_requests.product' | translate }}</h6>
                        <div class="product-row">
                            <div class="product-image" *ngIf="productPictureUrl()">
                                <img [src]="productPictureUrl()" [alt]="getProductName()">
                            </div>
                            <div class="product-image" *ngIf="!productPictureUrl()">
                                <div class="no-image">
                                    <i class="fa fa-image fa-2x text-muted"></i>
                                </div>
                            </div>
                            <div class="product-info">
                                <h5 class="product-name">{{ getProductName() }}</h5>
                                <span class="meta-badge">Qty: {{ request?.product?.qty }}</span>
                            </div>
                            <div class="product-price">{{ formatCurrency(request?.deliveringAmount) }}</div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h6 class="section-title">{{ 'delivery_requests.seller_info' | translate }}</h6>
                        <div class="info-row">
                            <div class="info-item">
                                <i class="fa fa-user me-2 text-muted"></i>
                                <span>{{ request?.seller?.firstName }} {{ request?.seller?.lastName }}</span>
                            </div>
                            <div class="info-item" *ngIf="request?.seller?.phone">
                                <i class="fa fa-phone me-2 text-muted"></i>
                                <span>{{ request?.seller?.phone }}</span>
                            </div>
                            <div class="info-item" *ngIf="request?.seller?.email">
                                <i class="fa fa-envelope me-2 text-muted"></i>
                                <span>{{ request?.seller?.email }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h6 class="section-title">{{ 'delivery_requests.pickup_address' | translate }}</h6>
                        <div class="address-card">
                            <i class="fa fa-box me-2 text-muted"></i>
                            <span>{{ pickupAddressString() }}</span>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h6 class="section-title">{{ 'delivery_requests.delivery_address' | translate }}</h6>
                        <div class="address-card">
                            <i class="fa fa-map-marker-alt me-2 text-muted"></i>
                            <span>{{ deliveryAddressString() }}</span>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h6 class="section-title">{{ 'delivery_requests.update_status' | translate }}</h6>
                        <div class="update-row">
                            <select [(ngModel)]="selectedStatus" class="form-select status-select" [disabled]="updating">
                                <option value="" disabled>{{ 'delivery_requests.select_status' | translate }}</option>
                                <option *ngFor="let s of deliveryStatuses" [value]="s.value">
                                    {{ s.labelKey | translate }}
                                </option>
                            </select>
                            <input [(ngModel)]="description" type="text" class="form-control desc-input"
                                   [placeholder]="'delivery_requests.description' | translate" [disabled]="updating">
                            <button (click)="updateStatus()" class="btn btn-success update-btn" [disabled]="updating || !selectedStatus">
                                <span *ngIf="updating" class="spinner-border spinner-border-sm me-1"></span>
                                {{ 'delivery_requests.update' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="col-md-3">
            <app-sidebar [currentUser]="user"></app-sidebar>
        </div>
    </div>
</div>